// extracted by mini-css-extract-plugin
export default {"table-container":"location-modal_table-container__yqDh9"};